'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64.js');
var modal = weex.requireModule('modal');
var dom = weex.requireModule('dom');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    special: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    isHighlight: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    extraContent: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    hasTextTip: {
      type: Boolean,
      default: false
    },
    badgeNum: {
      type: [Number, String],
      default: 0
    },
    badgeMax: {
      type: Number,
      default: 0
    },
    badgeTheme: {
      type: String,
      default: 'red'
    },
    badgeColor: {
      type: String,
      default: ''
    },
    hasDot: {
      type: Boolean,
      default: false
    },
    avatarIcon: {
      type: String,
      default: ''
    },
    // 使用字体图标
    avatarIconFont: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: 'big'
    },
    iconSizeCustom: {
      // { iconSize: 96, bgSize: 96 }
      type: Object,
      default: function _default() {
        return {};
      }
    },
    cellStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rightTextStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    hasTopBorder: {
      type: Boolean,
      default: false
    },
    hasTopSubBorder: {
      type: Boolean,
      default: false
    },
    hasBottomBorder: {
      type: Boolean,
      default: false
    },
    hasSubTopBorder: {
      type: Boolean,
      default: false
    },
    hasSubBottomBorder: {
      type: Boolean,
      default: false
    },
    hasMargin: {
      type: Boolean,
      default: false
    },
    hasVerticalIndent: {
      type: Boolean,
      default: true
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    rightText: {
      type: String,
      default: ''
    },
    rightTip: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoAccessible: {
      type: Boolean,
      default: true
    },
    fakeBorderStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    titleTextStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    descTextStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offset: 0,
      dragging: false
    };
  },

  computed: {
    badgeThemeList: function badgeThemeList() {
      return {
        brand: this._isDiablo ? '#0490d3' : '#00A4F2',
        red: this._isDiablo ? '#DB5C44' : '#F56428',
        purple: this._isDiablo ? '#805ed1' : '#946CF2',
        'blue-purple': this._isDiablo ? '#5865DC' : '#6575ff',
        blue: this._isDiablo ? '#25A8DC' : '#29c3ff',
        cyan: '#00cbb8',
        yellow: this._isDiablo ? '#BE8214' : '#FFAA10',
        orange: this._isDiablo ? '#db7122' : '#ff8225',
        'orange-red': '#ff6a4c',
        'gray-offline': this._isDiablo ? '#6B7587' : '#7c879b'
      };
    },
    arrowIcon: function arrowIcon() {
      return this._isDiablo ? icon.arrowIconNew_diablo : icon.arrowIconNew;
    },
    _backgroundColor: function _backgroundColor() {
      if (this.backgroundColor) return this.backgroundColor;
      return this._isColmo ? '#303237' : this._isDiablo ? '#101315' : '#ffffff';
    },
    _borderColor: function _borderColor() {
      return this._isColmo ? 'rgba(255,255,255,0.14)' : '#DDDDDD';
    },
    useFakeBorder: function useFakeBorder() {
      return JSON.stringify(this.fakeBorderStyle) !== '{}';
    },

    // cell样式
    cellStyleComp: function cellStyleComp() {
      var cellStyle = this.cellStyle,
          _backgroundColor = this._backgroundColor;

      return _extends({
        backgroundColor: _backgroundColor
      }, cellStyle);
    },
    dotNum: function dotNum() {
      var badgeNum = this.badgeNum,
          badgeMax = this.badgeMax;

      var value = '';
      var curContent = Number(badgeNum);
      if (badgeMax && curContent >= badgeMax) {
        value = badgeMax + '+';
      } else {
        value = badgeNum;
      }
      return value;
    },
    dotTipTop: function dotTipTop() {
      var iconSize = this.iconSize;

      var topClass = '';
      if (iconSize === 'max') {
        topClass = 'dotTopMax';
      } else if (iconSize === 'medium') {
        topClass = 'dotTopMedium';
      } else if (iconSize === 'min') {
        topClass = 'dotTopMin';
      } else {
        topClass = 'dotTopBig';
      }
      return topClass;
    },

    //处理特殊类型cell高度问题
    innerCellHeightComp: function innerCellHeightComp() {
      var special = this.special,
          desc = this.desc;

      if (special && desc) {
        return {
          minHeight: '200px',
          paddingTop: '32px'
        };
      }
      return '';
    },

    // 文字样式颜色
    textColorComp: function textColorComp() {
      var textColor = this.textColor;

      if (textColor) {
        return {
          color: textColor
        };
      } else {
        return {};
      }
    },
    titleStyleComp: function titleStyleComp() {
      var textColor = this.textColor,
          titleTextStyle = this.titleTextStyle;

      if (textColor) {
        return _extends({
          color: textColor
        }, titleTextStyle);
      } else {
        return _extends({}, titleTextStyle);
      }
    },
    descStyleComp: function descStyleComp() {
      var textColor = this.textColor,
          descTextStyle = this.descTextStyle;

      if (textColor) {
        return _extends({
          color: textColor
        }, descTextStyle);
      } else {
        return _extends({}, descTextStyle);
      }
    },
    avatarIconBgSizeComp: function avatarIconBgSizeComp() {
      var iconSize = this.iconSize,
          iconColor = this.iconColor;

      var iconSizeCustom = this.iconSizeCustom.bgSize;
      if (iconSizeCustom) {
        return {
          width: iconSizeCustom + 'px',
          height: iconSizeCustom + 'px',
          borderRadius: iconSizeCustom / 2 + 'px',
          backgroundColor: iconColor ? iconColor : 'transparent'
        };
      }
      if (iconSize === 'max') {
        return {
          width: '112px',
          height: '112px',
          borderRadius: '56px',
          marginTop: this._isColmo ? '0px' : '16px',
          marginBottom: this._isColmo ? '0px' : '16px',
          backgroundColor: iconColor ? iconColor : 'transparent'
        };
      } else if (iconSize === 'medium') {
        return {
          width: '76px',
          height: '76px',
          borderRadius: '38px',
          marginTop: this._isColmo ? '0px' : '40px',
          marginBottom: this._isColmo ? '0px' : '40px',
          backgroundColor: iconColor ? iconColor : 'transparent'
        };
      } else if (iconSize === 'min') {
        return {
          width: '58px',
          height: '58px',
          borderRadius: '20px',
          marginTop: this._isColmo ? '0px' : '32px',
          marginBottom: this._isColmo ? '0px' : '32px',
          backgroundColor: iconColor ? iconColor : 'transparent'
        };
      } else {
        return {
          width: '64px',
          height: '64px',
          borderRadius: '32px',
          marginTop: this._isColmo ? '0px' : '48px',
          marginBottom: this._isColmo ? '0px' : '48px',
          backgroundColor: iconColor ? iconColor : 'transparent'
        };
      }
    },
    avatarIconSizeComp: function avatarIconSizeComp() {
      var iconSize = this.iconSize;

      var iconSizeCustom = this.iconSizeCustom.iconSize;
      if (iconSizeCustom) {
        return {
          width: iconSizeCustom + 'px',
          height: iconSizeCustom + 'px',
          borderRadius: iconSizeCustom / 2 + 'px'
        };
      }
      if (iconSize === 'max') {
        return {
          width: '96px',
          height: '96px'
        };
      } else if (iconSize === 'medium') {
        return {
          width: '64px',
          height: '64px'
        };
      } else if (iconSize === 'min') {
        return {
          width: '40px',
          height: '40px'
        };
      } else {
        return {
          width: '48px',
          height: '48px'
        };
      }
    },
    avatarIconFontSize: function avatarIconFontSize() {
      var iconSize = this.iconSize;

      if (iconSize === 'max') {
        return 80;
      } else if (iconSize === 'medium') {
        return 40;
      } else if (iconSize === 'min') {
        return 24;
      } else {
        return 64;
      }
    },
    rightTextStyleComp: function rightTextStyleComp() {
      var textColor = this.textColor,
          rightTextStyle = this.rightTextStyle,
          avatarIcon = this.avatarIcon,
          iconSize = this.iconSize;

      if (textColor) {
        return _extends({
          color: textColor
        }, rightTextStyle);
      } else {
        return _extends({}, rightTextStyle);
      }
    },
    hackMrgb1pxcom: function hackMrgb1pxcom() {
      var hasSubBottomBorder = this.hasSubBottomBorder,
          hasBottomBorder = this.hasBottomBorder;

      return hasSubBottomBorder || hasBottomBorder ? true : false;
    },
    borderStyleComp: function borderStyleComp() {
      var _cellStyle$borderColo = this.cellStyle.borderColor,
          borderColor = _cellStyle$borderColo === undefined ? null : _cellStyle$borderColo,
          hasTopBorder = this.hasTopBorder,
          hasBottomBorder = this.hasBottomBorder;

      if (borderColor) {
        if (hasTopBorder) {
          return {
            borderTopWidth: '1px',
            borderTopColor: borderColor
          };
        } else if (hasBottomBorder) {
          return {
            borderBottomWidth: '1px',
            borderBottomColor: borderColor
          };
        } else {
          return {};
        }
      } else {
        if (hasTopBorder) {
          return {
            borderTopWidth: '1px',
            borderTopColor: this._borderColor
          };
        } else if (hasBottomBorder) {
          return {
            borderBottomWidth: '1px',
            borderBottomColor: this._borderColor
          };
        } else {
          return {};
        }
      }
    },
    subBorderStyleComp: function subBorderStyleComp() {
      var _cellStyle$borderColo2 = this.cellStyle.borderColor,
          borderColor = _cellStyle$borderColo2 === undefined ? null : _cellStyle$borderColo2,
          hasSubTopBorder = this.hasSubTopBorder,
          hasSubBottomBorder = this.hasSubBottomBorder;

      if (borderColor) {
        if (hasSubTopBorder) {
          return {
            borderTopWidth: '1px',
            borderTopColor: borderColor
          };
        } else if (hasSubBottomBorder) {
          return {
            borderBottomWidth: '1px',
            borderBottomColor: borderColor
          };
        } else {
          return {};
        }
      } else {
        if (hasSubTopBorder) {
          return {
            borderTopWidth: '1px',
            borderTopColor: this._borderColor
          };
        } else if (hasSubBottomBorder) {
          return {
            borderBottomWidth: '1px',
            borderBottomColor: this._borderColor
          };
        } else {
          return {};
        }
      }
    },
    badgeStyle: function badgeStyle() {
      var badgeTheme = this.badgeTheme,
          badgeThemeList = this.badgeThemeList,
          badgeColor = this.badgeColor;

      return {
        backgroundColor: badgeColor ? badgeColor : badgeThemeList[badgeTheme]
      };
    },

    // 底部border样式
    fakeBorderStyleRender: function fakeBorderStyleRender() {
      return _extends({
        backgroundColor: this._isColmo ? 'rgba(255,255,255,0.14)' : '#DDDDDD'
      }, this.fakeBorderStyle);
    }
  },
  methods: {
    onClick: function onClick() {
      var disabled = this.disabled;

      !disabled && this.$emit('dofCellClicked');
    },
    dofRightTipClicked: function dofRightTipClicked() {
      var rightTip = this.rightTip;

      rightTip && this.$emit('dofRightTipClicked');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-cell/index.vue
// module id = 316
// module chunks = 0 1